<nb-card class="dialog-card">
  <nb-card-header>Editar telefone — {{ pessoaNome || 'Pessoa' }}</nb-card-header>
  <nb-card-body>
    <label class="field-label" for="editTelFrequencia">Telefone / celular</label>
    <nb-form-field>
      <input
        nbInput
        fullWidth
        id="editTelFrequencia"
        type="tel"
        name="telefoneFrequencia"
        [mask]="mascaras.telefone"
        [(ngModel)]="telefone"
        autocomplete="tel"
        placeholder="(00) 00000-0000"
      />
    </nb-form-field>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <button nbButton status="basic" type="button" size="medium" (click)="cancelar()" [disabled]="salvando">
      Cancelar
    </button>
    <button nbButton status="primary" type="button" size="medium" (click)="salvar()" [disabled]="salvando">
      OK
    </button>
  </nb-card-footer>
</nb-card>
